// extracted by mini-css-extract-plugin
export default {"wrapper":"UniversalSelect_wrapper__5faJo","placeholder":"UniversalSelect_placeholder__knpGw"};